import apiInputService from "services/apiInputService";
import {
  logSystemData,
  logSystemDataPaginatedResponse,
  PaginatedLogSystemByZIDQuery,
} from "./@types";
import { useQuery } from "@tanstack/react-query";

const fetch = async ({
  zID,
  params,
}: PaginatedLogSystemByZIDQuery): Promise<logSystemDataPaginatedResponse> => {
  const { data }: any = await apiInputService.get(`/uv-log/${zID}`, {
    params: params,
  });

  const decodeDocsName = data.docs.map((doc: logSystemData) => {
    return {
      ...doc,
      subject: { ...doc.subject, value: decodeURI(doc.subject.value) },
    };
  });

  return {
    ...data,
    docs: decodeDocsName,
  } as logSystemDataPaginatedResponse;
};

export const useGetPaginatedLogSystem = (
  query: PaginatedLogSystemByZIDQuery,
  options?: any,
) =>
  useQuery([query.zID, query.params], () => fetch(query), {
    ...options,
    staleTime: 0,
  });
